import Image from '@global/Image'
import Button from '@global/Button'
import { Col, Row } from '@styles/global.styled'
import { Link } from '@routes'
import { useRouter } from 'next/router'
import * as S from './AgentHero.styled'
import vCardCreator from '@lib/helpers/vcard'
import IconDownload from '@icons/Download'
import ShareButton from '@global/ShareButton'
import React from 'react'
import Raiting from '@global/Raiting'

const AgentHeroActions = ({
  phone,
  isMobile,
  agentSlug,
  showGetInTouch,
  email,
  showSendEnquiry,
  shareObject,
  name,
  photo,
}) => {
  const router = useRouter()

  // Extract office slug from current path
  const getOfficeSlug = () => {
    const pathname = router.asPath || router.pathname
    const match = pathname.match(/\/offices\/([^/]+)\/our-team\//)
    return match ? match[1] : null
  }

  const officeSlug = getOfficeSlug()
  const enquiryUrl = officeSlug && agentSlug ? `/offices/${officeSlug}/our-team/${agentSlug}/enquiry/` : null

  return (
    <S.AgentHeroActions isMobile={isMobile}>
      {showGetInTouch && (
        <Link route={`/request-an-appraisal/${agentSlug}/`}>
          <Button color='secondary'>Request free Consultation</Button>
        </Link>
      )}
      <Row mbGutter={6}>
        {showSendEnquiry && email && enquiryUrl && (
          <Col xs={6} sm={6} md={12}>
            <Link route={enquiryUrl} passHref>
              <Button border color='secondary'>
                Send Enquiry
              </Button>
            </Link>
          </Col>
        )}
        <Col>
          {phone && (
            <a href={`tel:${phone}`} target='_blank'>
              <Button border color='secondary'>
                {`Call ${phone}`}
              </Button>
            </a>
          )}
        </Col>
        {isMobile && (
          <Col>
            <S.ShareAction>
              <S.SaveContact
                onClick={() => {
                  vCardCreator.makeVCard({
                    name: name,
                    tel: phone,
                    email,
                    photo,
                  })
                }}
              >
                <IconDownload /> Save
              </S.SaveContact>
              <ShareButton
                heading='Share this Agent'
                shareInfo={shareObject}
                modalPosition='right'
              />
            </S.ShareAction>
          </Col>
        )}
      </Row>
    </S.AgentHeroActions>
  )
}

const AgentHero = ({
  name,
  jobTitle,
  email,
  photo,
  phone,
  showGetInTouch,
  showSendEnquiry,
  agentSlug,
  shareObject,
  reaRating,
  reaNumberOfReviews,
}) => {
  const [firstName, ...lastName] = name.split(' ')

  return (
    <S.AgentHero>
      <S.AgentHeroInfo>
        <div>
          <S.AgentName>
            <span>{firstName}</span>
            <span>{lastName.join(' ')}</span>
          </S.AgentName>
          <S.AgentJobTitle>{jobTitle}</S.AgentJobTitle>
          <Raiting
            rating={reaRating}
            numberOfReviews={reaNumberOfReviews}
            isVertical
          />
        </div>
        <AgentHeroActions
          phone={phone}
          email={email}
          showGetInTouch={showGetInTouch}
          showSendEnquiry={showSendEnquiry}
          agentSlug={agentSlug}
        />
      </S.AgentHeroInfo>

      <S.AgentHeroImage>
        <Image src={photo?.url} alt={name} />
      </S.AgentHeroImage>
      <AgentHeroActions
        phone={phone}
        showGetInTouch={showGetInTouch}
        agentSlug={agentSlug}
        isMobile
        shareObject={shareObject}
        name={name}
        photo={photo}
      />
    </S.AgentHero>
  )
}

export default AgentHero
